export default function FacilitiesDirective() {
  return {
    template: require('./facilities.html'),
    scope: {
      assessmentFacilities: '=',
      status: '=',
      canEdit: '<',
    },
    controller: 'FacilitiesController',
    controllerAs: 'facilitiesVM',
    bindToController: true,
    replace: true,
  };
}
